import { useEffect, useState } from "react";

interface UseResendCooldownOptions {
  startActive?: boolean;
}

const useResendCooldown = (seconds: number, { startActive = false }: UseResendCooldownOptions = {}) => {
  const [cooldown, setCooldown] = useState(startActive ? seconds : 0);
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    if (cooldown === 0) return;

    const timer = setInterval(() => {
      setCooldown((current) => {
        if (current <= 1) {
          clearInterval(timer);
          return 0;
        }
        return current - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [cycle]);

  const start = () => {
    setCooldown(seconds);
    setCycle((current) => current + 1);
  };

  return { cooldown, start };
};

export default useResendCooldown;
